"use strict";

(function ($) {
  // Check if we're in admin/editor context
  var isAdmin = typeof wp !== 'undefined' && wp.domReady;

  // Initialize LazyLoad instance globally
  function initLazyLoad() {
    // Check if LazyLoad is available
    if (typeof LazyLoad === 'undefined') {
      console.warn('LazyLoad library not found');
      return;
    }

    // Create a single global instance if it doesn't exist
    if (!window.lazyLoadInstance) {
      window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        // For admin previews, use lower threshold to load images sooner
        threshold: isAdmin ? 0 : 300,
        // Load images immediately if already in viewport (useful for admin previews)
        load_delay: 0,
        // Ensure data-src is used (this is default, but being explicit)
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        // Add callback to handle loaded images
        callback_loaded: function callback_loaded(el) {
          // Image has been loaded - LazyLoad automatically sets src from data-src
          $(el).addClass('lazyloaded');
        },
        // Callback when element enters viewport
        callback_enter: function callback_enter(el) {
          // For admin previews, ensure images load immediately
          if (isAdmin && el.tagName === 'IMG' && el.dataset.src && !el.src) {
            el.src = el.dataset.src;
          }
        }
      });

      // For admin previews, manually trigger load for images already in viewport
      if (isAdmin) {
        setTimeout(function () {
          if (window.lazyLoadInstance) {
            // Force update to load visible images immediately
            window.lazyLoadInstance.update();
            // Also manually load any visible images
            $('.lazy[data-src]').each(function () {
              var $img = $(this);
              if ($img.is('img') && $img[0].dataset.src) {
                var rect = $img[0].getBoundingClientRect();
                // If image is visible in viewport, load it immediately
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                  $img[0].src = $img[0].dataset.src;
                  $img.addClass('lazyloaded');
                }
              }
            });
          }
        }, 200);
      }
    } else {
      // If instance exists, update it to include new elements
      window.lazyLoadInstance.update();

      // For admin, also manually trigger visible images
      if (isAdmin) {
        setTimeout(function () {
          $('.lazy[data-src]').each(function () {
            var $img = $(this);
            if ($img.is('img') && $img[0].dataset.src && !$img[0].src) {
              var rect = $img[0].getBoundingClientRect();
              if (rect.top < window.innerHeight && rect.bottom > 0) {
                $img[0].src = $img[0].dataset.src;
                $img.addClass('lazyloaded');
              }
            }
          });
        }, 100);
      }
    }
  }

  // Mobile / iOS: LazyLoad's IntersectionObserver often doesn't fire for viewport elements.
  // Manually apply data-bg and data-src so images show without relying on the library.
  function loadViewportLazyElements() {
    var lazy = document.querySelectorAll('.lazy');
    var vh = (window.innerHeight || document.documentElement.clientHeight) + 300;
    for (var i = 0; i < lazy.length; i++) {
      var el = lazy[i];
      if (el.classList.contains('lazyloaded')) continue;
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -50 || rect.top > vh) continue;
      var bg = el.getAttribute('data-bg');
      if (bg) {
        el.style.backgroundImage = 'url("' + bg.replace(/"/g, '%22') + '")';
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center';
        el.style.backgroundRepeat = 'no-repeat';
        el.classList.add('lazyloaded');
      }
      if (el.tagName === 'IMG') {
        var src = el.getAttribute('data-src');
        if (src && !el.src) {
          el.src = src;
          el.classList.add('lazyloaded');
        }
      }
    }
    if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
      window.lazyLoadInstance.update();
    }
  }
  function isMobileOrTouch() {
    var ua = navigator.userAgent || '';
    return /iPad|iPhone|iPod|Android|webOS|Mobile/i.test(ua) || 'ontouchstart' in window;
  }

  // Initialize on document ready
  $(document).ready(function () {
    setTimeout(function () {
      initLazyLoad();
      if (isMobileOrTouch()) {
        loadViewportLazyElements();
        setTimeout(loadViewportLazyElements, 200);
        setTimeout(loadViewportLazyElements, 600);
      }
    }, 100);
  });
  $(window).on('load', function () {
    if (isMobileOrTouch()) {
      loadViewportLazyElements();
      setTimeout(loadViewportLazyElements, 300);
    }
  });

  // For Gutenberg editor iframe (block previews)
  if (isAdmin && typeof wp !== 'undefined' && wp.domReady) {
    wp.domReady(function () {
      setTimeout(function () {
        initLazyLoad();
      }, 200);
    });
  }

  // Also listen for iframe load events (Gutenberg editor preview)
  $(window).on('load', function () {
    // Check for Gutenberg editor iframe
    var editorIframe = document.querySelector('iframe[name="editor-canvas"]') || document.querySelector('iframe.editor-canvas__iframe');
    if (editorIframe && editorIframe.contentDocument) {
      try {
        var iframeDoc = editorIframe.contentDocument;
        var iframeBody = iframeDoc.body;
        if (iframeBody) {
          // Initialize lazy load in iframe
          setTimeout(function () {
            if (typeof LazyLoad !== 'undefined' && !iframeDoc.lazyLoadInstance) {
              iframeDoc.lazyLoadInstance = new LazyLoad({
                elements_selector: ".lazy",
                threshold: 0,
                // Load immediately in admin
                load_delay: 0,
                data_src: "src",
                container: iframeBody
              });

              // Load visible images immediately
              var lazyImages = iframeBody.querySelectorAll('.lazy[data-src]');
              lazyImages.forEach(function (img) {
                if (img.tagName === 'IMG' && img.dataset.src) {
                  var rect = img.getBoundingClientRect();
                  if (rect.top < iframeDoc.defaultView.innerHeight && rect.bottom > 0) {
                    img.src = img.dataset.src;
                    img.classList.add('lazyloaded');
                  }
                }
              });
            }
          }, 300);
        }
      } catch (e) {
        // Cross-origin iframe, can't access
      }
    }
  });

  // MutationObserver to watch for new lazy elements being added to the DOM
  var domObserver = new MutationObserver(function (mutations) {
    var hasNewLazyElements = false;
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Element node
            // Check if the added node or its children have .lazy class
            if ($(node).hasClass('lazy') || $(node).find('.lazy').length > 0) {
              hasNewLazyElements = true;
            }
          }
        });
      }
    });

    // Update LazyLoad if new elements were added
    if (hasNewLazyElements && window.lazyLoadInstance) {
      setTimeout(function () {
        window.lazyLoadInstance.update();
        // For admin, manually load visible images that were just added
        if (isAdmin) {
          $('.lazy[data-src]').each(function () {
            var $img = $(this);
            if ($img.is('img') && $img[0].dataset.src && !$img[0].src) {
              var rect = $img[0].getBoundingClientRect();
              if (rect.top < window.innerHeight && rect.bottom > 0) {
                $img[0].src = $img[0].dataset.src;
                $img.addClass('lazyloaded');
              }
            }
          });
        }
      }, 100);
    } else if (hasNewLazyElements) {
      // Initialize if it doesn't exist yet
      initLazyLoad();
    }
  });

  // Start observing the document body for changes
  if (document.body) {
    domObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    // If body doesn't exist yet, wait for it
    $(document).ready(function () {
      domObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})(jQuery);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
jQuery(document).ready(function ($) {
  //loadMorePosts INSTRUCTIONS: ====
  //==============================
  //OPTIONS: 
  //var postsContainer: the container that contains all the posts. For example $('.blog-articles'). 
  //NOTE:  Make sure it is unique to the page.
  //var singlePost: the unit for each post. For example '.single-article'
  //var catSlug: default is 'all'. Used for when category is changed
  //var functionName: the PHP function to be called when the ajax demand is fired off
  //var filterClass: the class of the dropdown or radio input

  //ATTENTION: the following variables need to be defined on the page template itself (encoded in JSON) 

  //var maxNumPages: the maximum number of pages for that given post type 
  //var currentPage: keeps track of whichever page we're on

  //How to: 
  // Initiate an instance as follows:
  // 
  // const uniqueVariableNameHere = new loadMorePosts(postsContainer, singlePost, undefined, functionName);  
  // 
  // NOTE: leave variable as undefined when calling the function to assume
  // the default value

  // Set the dropdown or to match URL Parameter
  function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
  }
  var val = getURLParameter('filter');
  if (val !== null) {
    //blog dropdown filters
    $('#post-filters__dropdown').val(val); //  assign URL param to select field

    //blog button filters
    $("#categories-filter a").removeClass("active");
    $("#categories-filter").find("[data-value='" + val + "']").addClass('active');

    //Projects button filters
    $("#projects-filter a").removeClass("active");
    $("#projects-filter").find("[data-value='" + val + "']").addClass('active');
  }
  window.loadMorePosts = /*#__PURE__*/function () {
    function _class(postsContainer, singlePost, functionName, filterClass) {
      _classCallCheck(this, _class);
      this.postsContainer = postsContainer;
      this.singlePost = singlePost;
      this.functionName = functionName;
      this.filterClass = filterClass;
      this.canBeLoaded = true;
      this.currentPage = 1;
      this.run(); //run the methods automatically when a new object is instanced
    }
    return _createClass(_class, [{
      key: "loadThePosts",
      value: function loadThePosts() {
        var self = this;
        var loadingIconPath = "".concat(ajax_resources.theme_path, "/assets/images/icons/loading.gif");
        var loadingIcon = "<div class='ajax-loading-icon'><img src='".concat(loadingIconPath, "' alt='loading-icon'></div>");
        if (self.currentPage > self.maxNumPages) {
          return false;
        }
        $.ajax({
          url: ajax_resources.ajaxurl,
          type: 'post',
          data: {
            action: self.functionName,
            query_vars: ajax_resources.query_vars,
            'cat_slug': self.catSlug,
            'page': self.currentPage,
            'posts_per_page': self.postsPerPage,
            'orderby': self.orderBy,
            'order': self.order,
            'featured_post': self.featuredPost
          },
          beforeSend: function beforeSend(xhr) {
            // you can also add your own preloader here
            // you see, the AJAX call is in process, we shouldn't run it again until complete
            if (self.currentPage <= self.maxNumPages) {
              self.postsContainer.append(loadingIcon);
            }
            self.canBeLoaded = false;
          },
          success: function success(result) {
            if (result) {
              if (self.currentPage <= self.maxNumPages) {
                if (self.currentPage === 1) {
                  //if the category is changed or reset, and the page is back to 1              
                  $(self.singlePost).remove();
                }
                self.postsContainer.append(result);
                if ($('.grid').length) {
                  $('.grid').masonry('reloadItems').masonry();
                }
                self.canBeLoaded = true;
              }
            }
            $('.ajax-loading-icon').remove();

            // if (typeof lazyLoadInstance !== 'undefined') {
            //   lazyLoadInstance.update();
            // } else {
            //   console.warn('lazyLoadInstance is not defined.');
            // }

            // refresh stella parallax on ajax load
            $.stellar('refresh');
            triggerAnimation();
          },
          error: function error(xhr, status, _error) {
            $('.ajax-loading-icon').remove();
          }
        });
      }
    }, {
      key: "run",
      value: function run() {
        var self = this;
        if ($(self.postsContainer).length && $(self.singlePost).length) {
          self.setupCheck(); //check to see if system has been properly set up                              
          self.maxNumPages = $(self.postsContainer).attr('data-max-num-pages');
          self.postsPerPage = $(self.postsContainer).attr('data-posts-per-page');
          self.filterCategories = $(self.postsContainer).attr('data-filter-categories');
          self.order = $(self.postsContainer).attr('data-order');
          self.orderBy = $(self.postsContainer).attr('data-order-by');
          $(window).scroll(function () {
            var bottomOfPosts = self.postsContainer.offset().top + $(self.postsContainer).outerHeight();
            var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
            var topOfScreen = $(window).scrollTop();
            if (bottomOfScreen > bottomOfPosts - 300 && self.canBeLoaded === true) {
              self.currentPage++;
              self.loadThePosts();
            }
          });
        }
        if (typeof filterCategories !== 'undefined') {
          if (filterCategories !== 'all-projects') {
            this.catSlug = filterCategories;
            self.loadThePosts();
          }
          if (filterCategories !== 'all-articles') {
            this.catSlug = filterCategories;
            self.loadThePosts();
          }
        }
        self.changeCategoriesNav();
      }
    }, {
      key: "changeCategoriesNav",
      value: function changeCategoriesNav() {
        var self = this;
        if (self.filterClass) {
          if (self.filterClass.length) {
            // postFilterTitle.innerHTML('');

            //when dropdown changes, switch the posts to selected category
            if ($(self.filterClass).find('option').length) {
              self.filterClass.change(function () {
                //Change name of current cat selected
                // self.catSlug = $( this ).val();
                // var catName = $(this).find(':selected').data('name');
                // var postFilterTitle = document.getElementById('post-filters__selected-option');
                // if( self.catSlug == "all" ){
                //   self.catName = "All";
                // }
                // postFilterTitle.innerHTML = catName;

                self.currentPage = 1;
                self.catSlug = $(this).val();
                self.maxNumPages = $(this).children('option:selected').data('max-page');
                self.loadThePosts();
              });
            } else {
              self.filterClass.find('a').click(function () {
                if (!$(this).hasClass('active')) {
                  self.filterClass.find('a').removeClass('active');
                  $(this).addClass('active');
                  self.currentPage = 1;
                  self.catSlug = $(this).data('value');
                  self.maxNumPages = $(this).data('max-page');
                  self.loadThePosts();
                }
              });
            }
          }
        }
      }
    }, {
      key: "setupCheck",
      value: function setupCheck() {
        if ((typeof postsPerPage === "undefined" ? "undefined" : _typeof(postsPerPage)) === undefined || (typeof maxNumPages === "undefined" ? "undefined" : _typeof(maxNumPages)) == undefined || (typeof orderBy === "undefined" ? "undefined" : _typeof(orderBy)) == undefined || (typeof order === "undefined" ? "undefined" : _typeof(order)) == undefined) {
          console.log('Make sure to define var postsPerPage, maxNumPages, orderBy & order - then JSON encode them!');
          return false;
        }
        ;
      }
    }]);
  }();
  window.loadMorePostsInstances = function () {
    //instances of loadMorePosts

    /**  
     * BLOG POSTS | Filter dropdown
    */
    //const blogLoadMore = new loadMorePosts($('.blog-posts'), '.post-link',  'load_more_blogs', $('.post-filters__dropdown'));

    /**  
     * BLOG POSTS | Filter Button
    */
    var blogLoadMore = new loadMorePosts($('.blog-posts'), '.post-excerpt', 'load_more_blogs', $('#categories-filter'));

    // const authorLoadMore = new loadMorePosts($('.post-author'), '.post-excerpt',  'load_more_author_posts', $('#categories-author-posts'));

    /**  
     * FAQ POSTS | Filter Button
    */
    // const faqLoadMore = new loadMorePosts($('.faq-posts'), '.accordion__list',  'load_more_faqs', $('#faq-categories-filter'));

    // const faqLoadMore2 = new loadMorePosts($('.faq-posts'), '.accordion__list',  'load_more_faqs', $('#faq-categories__dropdown'));

    /**  
     * CASE STUDIES | Filter dropdown
    */
    // const caseStudiesLoadMore = new loadMorePosts( $('.case-study-posts'), '.case-study-excerpt',  'load_more_case_studies', null);

    /**  
     * PROJECTS | Filter dropdown
    */
    var projectLoadMore = new loadMorePosts($('.project-posts'), '.project-excerpt', 'load_more_project', $('.post-filters__dropdown'));

    //const projectLoadMore = new loadMorePosts( $('.project-posts'), '.project-link', 'load_more_project', $('.post-filters__dropdown'));

    /**  
     * PROJECTS | Filter Button
    */
    //const projectLoadMore = new loadMorePosts( $('.project-posts'), '.project-excerpt', 'load_more_project', $('#projects-filter'));

    /**  
     *  PORTAL | Filter dropdown
    */
    // const portalLoadMore = new loadMorePosts( $('.portal-posts'), '.portal-excerpt', 'load_more_portal', $('.portal-filters__dropdown'));

    /**  
     *  SEARCH
    */
    var searchLoadMore = new loadMorePosts($('.search-posts'), '.search-link', 'load_more_search', null);
  };
  loadMorePostsInstances();
});
"use strict";

jQuery(function ($) {
  function microsoft_object_fit_cover_fix() {
    if (/Edge/.test(navigator.userAgent)) {
      $('.entry-header__video__inner video').addClass('object-fit-cover-mimic');
      $('.image-container img').addClass('object-fit-cover-mimic');
    }
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0)
      // If Internet Explorer, return version number
      {
        $('.entry-header__video__inner video').addClass('object-fit-cover-mimic');
        $('.image-container img').addClass('object-fit-cover-mimic');
      }
  }
  microsoft_object_fit_cover_fix();
});
"use strict";

jQuery(document).ready(function ($) {
  var scroll = 0,
    $window = $(window),
    masthead = $('#masthead'),
    bannerHeight = $('.entry-header').outerHeight(true);
  $window.scroll(function () {
    if ($('body').hasClass('no-scroll')) {
      $window.scrollTop(scroll);
    } else {
      scroll = $window.scrollTop();
    }
    if (scroll >= bannerHeight - 110) {
      masthead.addClass("site-header--scrolled");
      masthead.find('#site-navigation').addClass("main-navigation--scrolled");
    } else {
      masthead.removeClass("site-header--scrolled");
      masthead.find('#site-navigation').removeClass("main-navigation--scrolled");
    }
  });

  // SLIDE NAV
  $(document).on('click', '[data-toggle="slide-collapse"]', function () {
    var navMenuCont = $($(this).data('target'));
    navMenuCont.toggleClass('opened');
    $('.menu-text').text("Close");
    if (!navMenuCont.hasClass('opened')) {
      navMenuCont.addClass('closed');
    } else {
      navMenuCont.removeClass('closed');
    }
    $("body").toggleClass('no-scroll');
    $(".hamburger").toggleClass('is-active');
  });

  // Nav overlay click slide Nav
  $(document).on('click', '.navbar__overlay', function () {
    var navMenuCont = $($('[data-toggle="slide-collapse"]').data('target'));
    navMenuCont.toggleClass('opened');
    if (!navMenuCont.hasClass('opened')) {
      navMenuCont.addClass('closed');
    } else {
      navMenuCont.removeClass('closed');
    }
    $("#site-navigation").toggleClass('toggled');
    $("body").toggleClass('no-scroll');
    $(".hamburger").toggleClass('is-active');
  });

  // When a same-page anchor link in #nav-items is clicked: close nav, toggle hamburger, then smooth scroll
  $(document).on('click', '#nav-items a', function () {
    var href = $(this).attr('href');
    if (!href || href === '#') return;
    var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#')) : '';
    if (!hash || hash === '#') return;
    var linkWithoutHash = this.href.replace(/#.*/, '');
    var pageUrl = location.origin + location.pathname + location.search;
    if (linkWithoutHash !== pageUrl) return;

    // Same-page anchor: close nav and hamburger (smooth scroll is handled by handler below)
    // if ($(window).width() < 992) {
    var navMenuCont = $('#nav-items');
    if (navMenuCont.hasClass('opened')) {
      navMenuCont.removeClass('opened').addClass('closed');
      $('body').removeClass('no-scroll');
      $('.hamburger').removeClass('is-active');
      $('#site-navigation').removeClass('toggled');
    }
    // }
  });

  // Close mobile menu when nav anchor link is clicked (links in #site-navigation or #nav-items)
  $(document).on('click', '#site-navigation a[href*="#"], #nav-items a[href*="#"]', function () {
    if ($(window).width() >= 992) return;
    var navMenuCont = $('#nav-items');
    if (!navMenuCont.hasClass('opened')) return;
    navMenuCont.removeClass('opened').addClass('closed');
    $('body').removeClass('no-scroll');
    $('.hamburger').removeClass('is-active');
    $('#site-navigation').removeClass('toggled');
  });

  // Smooth scroll when same-page anchor link is clicked
  $(document).on('click', 'a[href*="#"]', function (e) {
    var href = $(this).attr('href');
    if (href === '#' || href === '') return;
    var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#')) : '';
    if (!hash || hash === '#') return;
    var linkWithoutHash = this.href.replace(/#.*/, '');
    var pageUrl = location.origin + location.pathname + location.search;
    if (linkWithoutHash !== pageUrl) return;
    var $target = $(hash);
    if ($target.length) {
      e.preventDefault();
      $target[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      if (history.replaceState) {
        history.replaceState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
    }
  });
  $(window).resize(function () {
    if ($(window).width() >= 992) {
      if ($('body').hasClass('no-scroll')) {
        $('[data-toggle="slide-collapse"]').trigger("click");
        $('body').removeClass('no-scroll');
        alert('click');
      }
    } else {
      $('#nav-items').removeClass('closed');
    }
  });

  // function hasTouch() {
  //   return 'ontouchstart' in document.documentElement
  //          || navigator.maxTouchPoints > 0
  //          || navigator.msMaxTouchPoints > 0;
  // }
  // //make top line dropdown menu items clickable
  // $('.navbar .dropdown > a').click(function(){
  // 	if ($(window).width() >= 992) {
  // 		location.href = this.href;
  // 	}
  // });

  // if (hasTouch()) { // remove all :hover stylesheets
  // 		try { // prevent exception on browsers not supporting DOM styleSheets properly
  // 				for (var si in document.styleSheets) {
  // 						var styleSheet = document.styleSheets[si];
  // 						if (!styleSheet.rules) continue;

  // 						for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
  // 								if (!styleSheet.rules[ri].selectorText) continue;

  // 								if (styleSheet.rules[ri].selectorText.match(':hover')) {
  // 										styleSheet.deleteRule(ri);
  // 								}
  // 						}
  // 				}
  // 		} catch (ex) {}
  // }

  /**
   * File navigation.js.
   *
   * Handles toggling the navigation menu for small screens and enables TAB key
   * navigation support for dropdown menus.
   */

  var container, button, menu, links, i, len;
  container = document.getElementById('site-navigation');
  if (!container) {
    return;
  }
  button = container.getElementsByTagName('button')[0];
  if ('undefined' === typeof button) {
    return;
  }
  menu = container.getElementsByTagName('ul')[0];

  // Hide menu toggle button if menu is empty and return early.
  if ('undefined' === typeof menu) {
    button.style.display = 'none';
    return;
  }
  menu.setAttribute('aria-expanded', 'false');
  if (-1 === menu.className.indexOf('nav-menu')) {
    menu.className += ' nav-menu';
  }
  button.onclick = function () {
    if (-1 !== container.className.indexOf('toggled')) {
      container.className = container.className.replace(' toggled', '');
      button.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-expanded', 'false');
    } else {
      container.className += ' toggled';
      button.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-expanded', 'true');
    }
  };
});
"use strict";

(function ($) {
  function init() {
    // var carouselArrowSolid = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"17\" viewBox=\"0 0 14 17\"><path id=\"Polygon_3\" data-name=\"Polygon 3\" d=\"M8.5,0,17,14H0Z\" transform=\"translate(14) rotate(90)\" fill=\"#a7d500\"/></svg>";

    var carouselArrowSolid = "<svg width=\"19\" height=\"15\" viewBox=\"0 0 19 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.7071 8.07112C19.0976 7.6806 19.0976 7.04743 18.7071 6.65691L12.3431 0.292946C11.9526 -0.0975785 11.3195 -0.0975785 10.9289 0.292946C10.5384 0.68347 10.5384 1.31664 10.9289 1.70716L16.5858 7.36401L10.9289 13.0209C10.5384 13.4114 10.5384 14.0446 10.9289 14.4351C11.3195 14.8256 11.9526 14.8256 12.3431 14.4351L18.7071 8.07112ZM0 7.36401V8.36401H18V7.36401V6.36401H0V7.36401Z\" fill=\"currentColor\"/></svg>";
    var owlContainers = jQuery('.featured-projects-block');
    owlContainers.each(function (index, owlItem) {
      var $owlContainer = jQuery(owlItem);
      var $owl = $owlContainer.find('.project-item__owl-carousel');
      $owl.owlCarousel({
        loop: true,
        nav: true,
        margin: 20,
        navText: ["<span class=\"previous\" aria-label=\"Previous\">" + carouselArrowSolid + "</span>", "<span class=\"next\" aria-label=\"Next\">" + carouselArrowSolid + "</span>"],
        dots: false,
        autoplay: false,
        mouseDrag: true,
        touchDrag: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            slideBy: 1
          },
          540: {
            items: 2,
            slideBy: 2
          },
          850: {
            items: 3,
            slideBy: 3
          }
        }
      });
    });
    var owlContainers = jQuery('.testimonials-block');
    owlContainers.each(function (index, owlItem) {
      var $owlContainer = jQuery(owlItem);
      var $owl = $owlContainer.find('.testimonial__owl-carousel');
      $owl.owlCarousel({
        loop: true,
        items: 1,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 8000,
        autoplayHoverPause: true,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: false
      });
    });
    var owlContainers = jQuery('.image-carousel-block__dots');
    owlContainers.each(function (index, owlItem) {
      var $owlContainer = jQuery(owlItem);
      var $owl = $owlContainer.find('.image-carousel-block__owl-carousel');
      $owl.owlCarousel({
        loop: true,
        items: 1,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        mouseDrag: true,
        touchDrag: true,
        animateOut: 'fadeOut'
      });
    });
    var owlContainers = jQuery('.image-carousel-block__nav');
    owlContainers.each(function (index, owlItem) {
      var $owlContainer = jQuery(owlItem);
      var $owl = $owlContainer.find('.image-carousel-block__owl-carousel');
      $owl.owlCarousel({
        loop: true,
        items: 1,
        nav: true,
        dots: false,
        navText: ["<span class=\"previous\" aria-label=\"Previous\">" + carouselArrowSolid + "</span>", "<span class=\"next\" aria-label=\"Next\">" + carouselArrowSolid + "</span>"],
        autoplay: false,
        mouseDrag: true,
        touchDrag: true
      });
    });

    // Content Carousel: 2 full slides + right peek (lg+), 1 slide below lg
    var contentCarouselContainers = jQuery('.content-carousel-block');
    function getContentCarouselSlideWidth() {
      if (window.innerWidth < 992) {
        return null;
      }
      return Math.round((window.innerWidth - window.innerWidth * 0.06 - 48) / 2.12);
    }
    function syncContentCarouselWidths($owl) {
      var slideWidth = getContentCarouselSlideWidth();
      $owl.find('.owl-item').each(function () {
        if (slideWidth === null) {
          this.style.removeProperty('width');
          this.style.removeProperty('min-width');
          this.style.removeProperty('max-width');
        } else {
          this.style.setProperty('width', slideWidth + 'px', 'important');
          this.style.setProperty('min-width', slideWidth + 'px', 'important');
          this.style.setProperty('max-width', slideWidth + 'px', 'important');
        }
      });
    }
    function refreshContentCarousel($owl) {
      var instance = $owl.data('owl.carousel');
      if (!instance) {
        return;
      }
      syncContentCarouselWidths($owl);
      instance.invalidate('width');
      instance.update();
    }
    function initContentCarousel($owlContainer, startIndex) {
      var $owl = $owlContainer.find('.content-carousel-block__owl-carousel');
      if (!$owl.length || $owl.hasClass('owl-loaded')) {
        return;
      }
      startIndex = startIndex || 0;
      $owl.owlCarousel({
        loop: false,
        nav: true,
        dots: false,
        margin: 24,
        navText: ["<span class=\"previous\" aria-label=\"Previous\">" + carouselArrowSolid + "</span>", "<span class=\"next\" aria-label=\"Next\">" + carouselArrowSolid + "</span>"],
        autoplay: false,
        mouseDrag: true,
        touchDrag: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            slideBy: 1,
            autoWidth: false
          },
          992: {
            items: 1,
            slideBy: 1,
            autoWidth: true
          }
        },
        onInitialized: function onInitialized(event) {
          var $carousel = jQuery(event.target);
          refreshContentCarousel($carousel);
          if (startIndex > 0) {
            var instance = $carousel.data('owl.carousel');
            var maxIndex = instance ? instance.maximum() : 0;
            $carousel.trigger('to.owl.carousel', [Math.min(startIndex, maxIndex), 0, true]);
          }
        }
      });
      var $navWrap = $owlContainer.find('.content-carousel-block__nav-wrap');
      if ($navWrap.length && $owl.find('.owl-nav').length) {
        $owl.find('.owl-nav').appendTo($navWrap);
      }
    }
    function reloadContentCarousel($owlContainer) {
      var $owl = $owlContainer.find('.content-carousel-block__owl-carousel');
      if (!$owl.length) {
        return;
      }
      var instance = $owl.data('owl.carousel');
      var startIndex = instance ? instance.current() : 0;
      if (instance) {
        $owl.trigger('destroy.owl.carousel');
      }
      initContentCarousel($owlContainer, startIndex);
    }
    contentCarouselContainers.each(function (index, owlItem) {
      initContentCarousel(jQuery(owlItem), 0);
    });
    var contentCarouselResizeTimer;
    jQuery(window).off('resize.contentCarouselBlock').on('resize.contentCarouselBlock', function () {
      window.clearTimeout(contentCarouselResizeTimer);
      contentCarouselResizeTimer = window.setTimeout(function () {
        contentCarouselContainers.each(function () {
          reloadContentCarousel(jQuery(this));
        });
      }, 250);
    });
    $('.logos-block .owl-carousel').owlCarousel({
      loop: true,
      margin: 20,
      nav: false,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 2,
          slideBy: 2
        },
        540: {
          items: 3,
          slideBy: 3
        },
        768: {
          items: 4,
          slideBy: 4
        },
        1100: {
          items: 4,
          slideBy: 4
        }
      }
    });
    function counter(event) {
      var element = event.target; // DOM element, in this example .owl-carousel
      var items = event.item.count; // Number of items
      var item = event.item.index + 1; // Position of the current item

      // it loop is true then reset counter from 1
      if (item > items) {
        item = item - items;
      }
      jQuery(element).parent().find('.counter').html(item + " / " + items);
      var elmnt = jQuery(element).closest('.content-carousel-g-block').attr('id');
      if (event.type === 'translated') {
        $('html, body').animate({
          scrollTop: $('#' + elmnt).position().top - 90
        }, 'fast');
      }
    }
  }

  // Run when a document ready on the front end.
  $(document).ready(init);

  // Run when a block preview is done loading.
  $(document).on('mb_blocks_preview .owl-carousel', init);
})(jQuery);
"use strict";

jQuery(document).ready(function ($) {
  var isMobile = {
    Android: function Android() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
  };

  // Debounce function to prevent too many refreshes
  function debounce(func, wait) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  // Debounced Stellar refresh function
  var debouncedStellarRefresh = debounce(function () {
    if (typeof $.fn.stellar === 'function' && $(window).data('stellar') && $(window).width() >= 576) {
      $.stellar('refresh');
    }
  }, 250); // Wait 250ms before refreshing

  $(window).resize(function () {
    debouncedStellarRefresh();
  });
  function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight,
      newHeight;
    (function run() {
      newHeight = elm.clientHeight;
      if (lastHeight != newHeight) {
        callback(newHeight);
      }
      lastHeight = newHeight;
      if (elm.onElementHeightChangeTimer) clearTimeout(elm.onElementHeightChangeTimer);
      elm.onElementHeightChangeTimer = setTimeout(run, 500); // Increased from 200 to 500ms to reduce frequency
    })();
  }
  onElementHeightChange(document.body, function (h) {
    debouncedStellarRefresh();
  });

  // Hide banner images initially until parallax is ready (desktop only)
  function hideBannerImages() {
    $('.entry-header__desktop-image .entry-header__image__inner[data-stellar-background-ratio]').each(function () {
      var $el = $(this);
      if ($(window).width() >= 576) {
        // Add a class to hide the image
        $el.addClass('parallax-image-hidden');
      }
    });
  }

  // Trigger text animation for banner h1
  function triggerBannerTextAnimation() {
    if (typeof $.fn.textyle === 'function') {
      $('.entry-header .entry-header__header.text_animation').each(function () {
        var $textEl = $(this);
        // Only trigger if not already animated
        if (!$textEl.data('textyle-animated')) {
          $textEl.data('textyle-animated', true);
          $textEl.textyle({
            duration: 150,
            delay: 40,
            easing: 'swing'
          });
        }
      });
    }
  }

  // Show banner images after parallax is ready
  function showBannerImages() {
    $('.entry-header__desktop-image .entry-header__image__inner[data-stellar-background-ratio]').each(function () {
      var $el = $(this);

      // Ensure background-size is locked before showing
      $el.css('background-size', 'cover !important');

      // Remove hidden class to trigger fade-in
      $el.removeClass('parallax-image-hidden');

      // Force visibility and opacity after a tiny delay to ensure smooth transition
      setTimeout(function () {
        $el.css({
          'opacity': '1',
          'visibility': 'visible',
          'background-size': 'cover'
        });
      }, 10);
    });

    // Trigger text animation for h1 in banner at the same time as image fade-in
    triggerBannerTextAnimation();
  }
  function initStellar() {
    if ($(window).width() < 576) {
      if ($(window).data('stellar')) {
        $.stellar('destroy');
      }
      // Show images on mobile (no parallax)
      showBannerImages();

      // Trigger text animation on mobile immediately (no parallax delay)
      triggerBannerTextAnimation();
    } else {
      // Check if Stellar is already initialized
      if (typeof $.fn.stellar === 'function') {
        // If already initialized, refresh to pick up new elements
        if ($(window).data('stellar')) {
          // Refresh to pick up any new parallax elements
          debouncedStellarRefresh();
          return;
        } else {
          // Initialize Stellar for the first time
          $(window).stellar({
            horizontalScrolling: false,
            verticalScrolling: !isMobile.any(),
            horizontalOffset: 0,
            verticalOffset: 0,
            responsive: true,
            scrollProperty: 'scroll',
            positionProperty: 'transform',
            parallaxElements: true,
            hideDistantElements: false // Changed to false to prevent flickering
          });

          // Wait for Stellar to fully initialize, then show images
          setTimeout(function () {
            // Ensure background-size is locked before showing
            $('.entry-header__desktop-image .entry-header__image__inner[data-stellar-background-ratio]').each(function () {
              var $el = $(this);
              // Force background-size to cover and ensure it stays
              $el.css('background-size', 'cover');

              // Use requestAnimationFrame to ensure style is applied
              requestAnimationFrame(function () {
                $el.css('background-size', 'cover');
              });
            });

            // Wait one more frame to ensure Stellar has finished all calculations
            requestAnimationFrame(function () {
              // Ensure background-size one more time
              $('.entry-header__desktop-image .entry-header__image__inner[data-stellar-background-ratio]').css('background-size', 'cover');

              // Now show the images with fade-in
              showBannerImages();
            });
          }, 500);
        }
      }
    }
  }

  // Run on DOM ready to add hidden class (desktop only - prevents flash during parallax init)
  $(document).ready(function () {
    hideBannerImages();
  });

  // Wait for window load to ensure images are loaded before initializing parallax
  // This prevents size jumps when parallax initializes
  var stellarInitialized = false;
  function initStellarOnLoad() {
    if (!stellarInitialized && $(window).width() >= 576) {
      initStellar();
      stellarInitialized = true;
    } else if ($(window).width() < 576) {
      // Show images on mobile immediately (no parallax)
      showBannerImages();
    }
  }

  // Initialize on window load to ensure images are loaded
  $(window).on('load', function () {
    initStellarOnLoad();
  });

  // Fallback: show images if still hidden after 2s (e.g. if Stellar fails or JS error)
  setTimeout(function () {
    $('.entry-header__desktop-image .entry-header__image__inner.parallax-image-hidden').each(function () {
      $(this).removeClass('parallax-image-hidden').css({
        opacity: '1',
        visibility: 'visible'
      });
    });
  }, 2000);

  // Also initialize on DOM ready if window is already loaded
  if (document.readyState === 'complete') {
    setTimeout(initStellarOnLoad, 100);
  } else {
    // On DOM ready, hide images if not already hidden
    $(document).ready(function () {
      hideBannerImages();
    });
  }
  $(window).resize(function () {
    if (stellarInitialized) {
      debouncedStellarRefresh();
    } else {
      initStellar();
    }
  });

  // Watch for new elements with data-stellar-ratio being added to the DOM
  var parallaxRefreshTimeout;
  var parallaxObserver = new MutationObserver(function (mutations) {
    var hasNewParallaxElements = false;
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Element node
            // Check if the added node or its children have data-stellar-ratio
            if ($(node).find('[data-stellar-ratio]').length > 0 || $(node).attr('data-stellar-ratio')) {
              hasNewParallaxElements = true;
            }
          }
        });
      }
    });

    // Debounce the refresh to prevent flickering
    if (hasNewParallaxElements && $(window).width() >= 576) {
      clearTimeout(parallaxRefreshTimeout);
      parallaxRefreshTimeout = setTimeout(function () {
        if (typeof $.fn.stellar === 'function') {
          // If Stellar is not initialized yet, initialize it
          if (!$(window).data('stellar')) {
            initStellar();
          } else {
            // Otherwise just refresh
            debouncedStellarRefresh();
          }
        }
      }, 500); // Increased delay to ensure elements are fully rendered
    }
  });

  // Start observing the document body for changes
  parallaxObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
"use strict";

jQuery(document).ready(function ($) {
  function init() {
    // Do something.
    if ($('.video-modal').length) {
      $('.video-modal').insertAfter('#page');
      var player;

      //on video button click, play video
      if ($('*[data-toggle="modal"]').length) {
        var playAndPauseVideo = function playAndPauseVideo(btn) {
          $(btn).on("click", function () {
            // $(btn).click(function(){      
            var videoId = $(this).data('target');
            var iframe = $(videoId).find('iframe');
            if (typeof iframe !== 'undefined') {
              if (iframe.attr('src').includes("player.vimeo")) {
                player = new Vimeo.Player(iframe);
                player.play();
                $(videoId).on('hidden.bs.modal', function (e) {
                  player.pause();
                });
              } else if (iframe.attr('src').includes("youtu")) {
                // var tag = document.createElement('script');
                // tag.src = "https://www.youtube.com/iframe_api";
                // var firstScriptTag = document.getElementsByTagName('script')[0];
                // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                var ogSrc = iframe.attr('src');
                var autoplaySrc = ogSrc + "&autoplay=1";
                $(iframe).attr('src', autoplaySrc);
                $(videoId).on('hidden.bs.modal', function (e) {
                  $(iframe).attr('src', ogSrc);
                });
              }
            }
          });
        }; //embed video modal block
        //add the playVideo function to differnet button types
        playAndPauseVideo($('.embed-video-modal-g-block__video-wrapper-btn'));
        playAndPauseVideo($('.content-50-50-g-block__video-wrapper-btn'));
      }
    }
  }

  // Run when a document ready on the front end.
  $(document).ready(init);

  // Run when a block preview is done loading.
  $(document).on('mb_blocks_preview', init);

  // Run only on embed-video-modal-g-block when all block previews is done loading.
  $(document).on('mb_blocks_preview .content-50-50-g-block', function (e) {
    $(this).click(function () {
      $(this).find('.modal-backdrop').css("display", 'none');
    });
  });
  $(document).on('mb_blocks_preview .embed-video-modal-g-block', function (e) {
    $(this).click(function () {
      $(this).find('.modal-backdrop').css("display", 'none');
    });
  });
});
"use strict";

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
(function () {
  var isIe = /(trident|msie)/i.test(navigator.userAgent);
  if (isIe && document.getElementById && window.addEventListener) {
    window.addEventListener('hashchange', function () {
      var id = location.hash.substring(1),
        element;
      if (!/^[A-z0-9_-]+$/.test(id)) {
        return;
      }
      element = document.getElementById(id);
      if (element) {
        if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
          element.tabIndex = -1;
        }
        element.focus();
      }
    }, false);
  }
})();
"use strict";

jQuery(function ($) {
  window.triggerAnimation = function () {
    var Animate = document.querySelectorAll('.animation-item');
    var options = {
      root: null,
      rootMargin: "0px",
      threshold: [0.0]
    };
    if ('IntersectionObserver' in window) {
      var handleIntersectionAnimate = function handleIntersectionAnimate(entries) {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            var animationType = $(entry.target).attr('data-animation');
            entry.target.classList.add(animationType);
            entry.target.classList.add('animate__animated');
            observer.unobserve(entry.target);
          }
        });
      };
      var observer = new IntersectionObserver(handleIntersectionAnimate, options);
      Animate.forEach(function (Animate) {
        return observer.observe(Animate);
      });
    } else {
      console.log('Please use a modern browser');
    }
  };
  triggerAnimation();
});
"use strict";

jQuery(function ($) {
  // Set the dropdown or to match URL Parameter
  function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
  }
  var val = getURLParameter('filter');
  if (val !== null) {
    //dropdown filters
    $('#post-filters__dropdown').val(val); //  assign URL param to select field

    //list filters
    $("#categories-filter a").removeClass("active");
    $("#categories-filter").find("[data-value='" + val + "']").addClass('active');
  }

  // BLOG filter  Scroll
  if (window.location.href.indexOf("?filter=") > -1) {
    $('html, body').animate({
      scrollTop: $("#filters-wrapper").offset().top - 72
    }, 10);
  }
});